import type { WorkflowAutoCreationRuleNoticeEntry } from '@ebalance/proto/bffuser/v1/global_alert_model_pb'

import type { SideMenuDot } from '~/models/sideMenuDot'
import { routePaths } from '~/routes/routePaths'

/**
 * AC-SC-044 (AC-WFT-050 の分): 起票していない自動起票ルールが 1 つでもあれば、業務ワークフローの
 * 一覧の項目に黄のドットを作る。親グループのドットは子の項目からまとめる
 * (`resolveGroupSideMenuDot`)。どのルールが知らせの対象かは backend が決め、ここでは導き直さない。
 * 項目とグループは React mock `navAlerts.ts` の `autoRuleBgUnresolved` と同じ (業務ワークフローは
 * 需要想定の配下ではなく独立したグループ)。
 *
 * @param reason 表示文言 (i18n 解決済み)
 */
export const workflowAutoCreationNoticeDots = (
  rules: readonly WorkflowAutoCreationRuleNoticeEntry[],
  reason: string,
): Array<readonly [string, SideMenuDot]> =>
  rules.length === 0
    ? []
    : [
        [
          routePaths.workflowCases.path,
          { severity: 'warning', reasons: [reason] },
        ] as const,
      ]
